export default __webpack_public_path__ + "static/media/favicon.923bb46c.ico";